module.exports = __webpack_public_path__ + "static/img/share.37e5fff0.jpg";